/**
 * @file Compteur de jetons d'herbe a chat (hub uniquement) : pastille « feuille N » qui fait un petit bond a chaque brindille cueillie.
 */
import { Component } from '../core/Component';
import { h, setText } from '../core/dom';
import { uiIcon } from '../core/uiIcons';
import type { UiContext } from '../UiContext';

export class CatnipCounter extends Component {
  private value!: HTMLElement;
  private shown = -1;
  private mult!: HTMLElement;

  constructor(ctx: UiContext) {
    super(ctx, 'div', 'catnip-counter');
  }

  protected build(): void {
    this.el.title = this.ctx.i18n.t('hub.catnip');
    this.value = h('b', {}, '0');
    this.mult = h('span', { class: 'catnip-mult is-hidden' });
    this.el.append(h('span', { class: 'catnip-icon' }, uiIcon('leaf')), this.value, this.mult);
    this.update(0);
  }

  override update(_dt: number): void {
    const m = this.ctx.online?.catnipMultiplier ?? 1;
    setText(this.mult, `x${m}`);
    this.mult.classList.toggle('is-hidden', m <= 1);
    const n = this.ctx.sim.data.hub.catnip;
    if (n === this.shown) return;
    if (this.shown >= 0) {
      this.el.classList.remove('bump');
      void this.el.offsetWidth;
      this.el.classList.add('bump');
    }
    this.shown = n;
    setText(this.value, String(n));
  }
}
